export const standard_datetime = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "640px",
    height: "432px",
    padding: "0%",
    borderRadius: "0px",
    border: "none"
  },
};

export const standard_date = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "432px",
    padding: "0%",
    borderRadius: "0px",
    border: "none"
  },
};

export const modalTime = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "432px",
    padding: "0%",
    borderRadius: "0px",
    border: "none"
  },
}
